import { ReferenceImageMatch } from "@/dev/sample-out-of-stock-predictions";
import { useFetchGalleryImgUrl } from "@/hooks/useFetchGalleryImgUrl";
import { useCoverageBetaStore } from "@/store/useCoverageBetaStore";
import { cn } from "@/utils/utils";
import { ImageContextSchema } from "@augmodo/lebron-browser-client";
import { isEmpty } from "lodash";

interface Props {
  reference: ImageContextSchema;
  isActive: boolean;
  refIdx: number;
  refImageMatches: ReferenceImageMatch[];
}
export const ReferenceImageThumbnail = (props: Props) => {
  const { reference, isActive, refIdx, refImageMatches } = props;
  const { data: referenceImgResp } = useFetchGalleryImgUrl(reference.image_id);
  const referenceImgObjUrl = referenceImgResp?.objUrl || "";
  const setActiveRefImgIdx = useCoverageBetaStore((s) => s.setActiveRefImgIdx);
  const recordInteraction = useCoverageBetaStore((s) => s.recordInteraction);

  if (!referenceImgObjUrl) return null;

  return (
    <div
      className={cn(
        "relative w-10 rounded-sm  border border-gray-500 shadow",
        isActive && "ring-2 ring-blue-400",
      )}
      onClick={() => {
        setActiveRefImgIdx(refIdx);
        recordInteraction("ref_nav", "click");
      }}
    >
      <div
        className={cn(
          "opacity-70 hover:opacity-90 cursor-pointer",
          isActive && "opacity-100",
        )}
      >
        {/* Thumbnails reuse the full optimized image; load them behind the
            active query/reference images so those paint first on slow links. */}
        <img src={referenceImgObjUrl} fetchpriority="low" />
      </div>

      {!isEmpty(refImageMatches) && (
        <div className="bg-blue-500 rounded-xl size-3.5 text-[10px] absolute -top-2 -right-2 text-white flex justify-center items-center">
          {refImageMatches.length}
        </div>
      )}
    </div>
  );
};
